export const SUCCESS = '_SUCCESS';
export const FAILURE = '_FAILURE';
export const REQUEST = 'REQUEST';

export const PAGE_SIZE_10 = 10;
export const PAGE_SIZE_20 = 20;
export const PAGE_SIZE_50 = 50;
